import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentWrapper, { VerticalCenter } from './content-wrapper';
import FooterItem from './footer-item';
import { changeTitle } from '../util';

class Loading extends Component {
  componentWillMount() {
    const { onEnter } = this.props;
    onEnter();
  }

  componentDidMount() {
    const { title } = this.props;
    changeTitle(title);
  }

  render() {
    return (
      <ContentWrapper>
        <VerticalCenter>
          <FooterItem loading={true} />
        </VerticalCenter>
      </ContentWrapper>
    );
  }
}

Loading.defaultProps = {
  title: '正在加载',
};

Loading.propTypes = {
  onEnter: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading.jsx